import { render, staticRenderFns } from "./workflow_form_model_list.vue?vue&type=template&id=86572504&scoped=true"
import script from "./workflow_form_model_list.vue?vue&type=script&lang=js"
export * from "./workflow_form_model_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86572504",
  null
  
)

export default component.exports